// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locations-map-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 0 40px;
}

/* ── Two-column split: 40% events | 60% map ─────────────── */
.find-us-split {
  display: block; /* single column when no events */
}

.find-us-events-col {
  display: none; /* hidden when no events */
}

.find-us-split--active {
  display: grid;
  grid-template-columns: 2fr 3fr; /* 40% | 60% */
  gap: 40px;
  align-items: start;
}

.find-us-split--active .find-us-events-col {
  display: block;
  position: sticky;
  top: 80px; /* below fixed navbar */
}

.find-us-map-col {
  min-width: 0;
}

/* ── Locations header — shared, above the split ─────────── */
.locations-header {
  text-align: center;
  margin-bottom: 36px;
}

.locations-header h2 {
  font-size: 2.5rem;
  color: #3D1818;
  margin: 0;
  font-family: 'Playfair Display', serif;
  font-weight: 200;
  letter-spacing: 3px;
  text-transform: uppercase;
}

/* Subtitle inside the map column */
.locations-subheader {
  font-size: 1rem;
  color: #5D3A3A;
  margin: 0 0 20px 0;
  font-style: italic;
}

/* ── City tabs ───────────────────────────────────────────── */
.city-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  justify-content: center;
}

.find-us-split--active .city-tabs {
  justify-content: flex-start;
}

.city-tab {
  padding: 10px 20px;
  background: white;
  border: 2px solid #E8D5B7;
  color: #3D1818;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.city-tab:hover {
  background: #F7E9D2;
  border-color: #D4A574;
}

.city-tab.active {
  background: linear-gradient(135deg, #7B2323 0%, #3D1818 100%);
  border-color: #7B2323;
  color: white;
  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);
}

/* ── Map content ─────────────────────────────────────────── */
.map-content {
  position: relative;
}

.city-map-section {
  display: none;
}

.city-map-section.active {
  display: block;
}

/* map 2/3 | list 1/3 inside the right column */
.map-and-list {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.map-container {
  width: 100%;
  height: 460px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.locations-list {
  max-height: 460px;
  overflow-y: auto;
  padding-right: 8px;
}

.locations-list::-webkit-scrollbar {
  width: 6px;
}

.locations-list::-webkit-scrollbar-track {
  background: #F7E9D2;
  border-radius: 4px;
}

.locations-list::-webkit-scrollbar-thumb {
  background: #D4A574;
  border-radius: 4px;
}

.locations-list::-webkit-scrollbar-thumb:hover {
  background: #C19A6B;
}

.location-item {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: #FAF6E7;
  border-radius: 10px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  border-left: 4px solid #D4A574;
}

.location-item:hover {
  background: #F7E9D2;
  transform: translateX(3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.location-item[style*="cursor: pointer"]:hover {
  background: #E8D5B7;
  border-left-color: #7B2323;
}

.location-item[style*="cursor: pointer"]:active {
  transform: translateX(2px);
}

.location-icon {
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 6px;
  flex-shrink: 0;
}

.location-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.location-details {
  flex: 1;
  min-width: 0;
}

.location-details h4 {
  margin: 0 0 4px 0;
  font-size: 0.95rem;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.location-type {
  margin: 0 0 3px 0;
  font-size: 0.82rem;
  color: #7B2323;
  font-weight: 600;
}

.location-type a {
  color: #7B2323;
  text-decoration: none;
  transition: color 0.2s ease;
}

.location-type a:hover {
  color: #3D1818;
  text-decoration: underline;
}

.location-address {
  margin: 0;
  font-size: 0.8rem;
  color: #5D3A3A;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Responsive ──────────────────────────────────────────── */
@media (max-width: 1100px) {
  .find-us-split--active {
    grid-template-columns: 1fr; /* stack on medium screens */
  }

  .find-us-split--active .find-us-events-col {
    position: static;
  }

  .map-and-list {
    grid-template-columns: 3fr 2fr;
  }
}

@media (max-width: 768px) {
  .locations-header h2 {
    font-size: 2rem;
    letter-spacing: 2px;
  }

  .locations-subheader {
    font-size: 0.95rem;
  }

  .city-tabs {
    gap: 8px;
  }

  .city-tab {
    padding: 8px 14px;
    font-size: 0.85rem;
  }

  .map-and-list {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .map-container {
    height: 300px;
  }

  .locations-list {
    max-height: none;
  }

  .location-item {
    padding: 10px;
  }

  .location-icon {
    min-width: 32px;
    height: 32px;
  }

  .location-details h4 {
    font-size: 0.9rem;
    white-space: normal;
  }

  .location-address {
    white-space: normal;
  }
}

/* ── Calendar teaser ── */
.locations-header-sub {
  font-size: 1rem;
  color: #6b5050;
  margin: 8px 0 0;
}

.locations-calendar-teaser {
  text-align: center;
  padding: 36px 24px 48px;
  border-top: 1px solid rgba(61,24,24,.08);
  margin-top: 32px;
}

.locations-calendar-teaser p {
  font-size: 1rem;
  color: #5a4040;
  margin: 0 0 12px;
}

.locations-calendar-link {
  display: inline-block;
  padding: 10px 24px;
  background: #7b2323;
  color: #fff;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  transition: background .2s, transform .2s;
}

.locations-calendar-link:hover {
  background: #5a1a1a;
  transform: translateY(-1px);
}
`, "",{"version":3,"sources":["webpack://./src/components/LocationsMap.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,cAAc,EAAE,iCAAiC;AACnD;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,cAAc;EAC9C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS,EAAE,uBAAuB;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,+DAA+D;AAC/D;EACE;IACE,0BAA0B,EAAE,4BAA4B;EAC1D;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":[".locations-map-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 0 40px;\n}\n\n/* ── Two-column split: 40% events | 60% map ─────────────── */\n.find-us-split {\n  display: block; /* single column when no events */\n}\n\n.find-us-events-col {\n  display: none; /* hidden when no events */\n}\n\n.find-us-split--active {\n  display: grid;\n  grid-template-columns: 2fr 3fr; /* 40% | 60% */\n  gap: 40px;\n  align-items: start;\n}\n\n.find-us-split--active .find-us-events-col {\n  display: block;\n  position: sticky;\n  top: 80px; /* below fixed navbar */\n}\n\n.find-us-map-col {\n  min-width: 0;\n}\n\n/* ── Locations header — shared, above the split ─────────── */\n.locations-header {\n  text-align: center;\n  margin-bottom: 36px;\n}\n\n.locations-header h2 {\n  font-size: 2.5rem;\n  color: #3D1818;\n  margin: 0;\n  font-family: 'Playfair Display', serif;\n  font-weight: 200;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n}\n\n/* Subtitle inside the map column */\n.locations-subheader {\n  font-size: 1rem;\n  color: #5D3A3A;\n  margin: 0 0 20px 0;\n  font-style: italic;\n}\n\n/* ── City tabs ───────────────────────────────────────────── */\n.city-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.find-us-split--active .city-tabs {\n  justify-content: flex-start;\n}\n\n.city-tab {\n  padding: 10px 20px;\n  background: white;\n  border: 2px solid #E8D5B7;\n  color: #3D1818;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.city-tab:hover {\n  background: #F7E9D2;\n  border-color: #D4A574;\n}\n\n.city-tab.active {\n  background: linear-gradient(135deg, #7B2323 0%, #3D1818 100%);\n  border-color: #7B2323;\n  color: white;\n  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);\n}\n\n/* ── Map content ─────────────────────────────────────────── */\n.map-content {\n  position: relative;\n}\n\n.city-map-section {\n  display: none;\n}\n\n.city-map-section.active {\n  display: block;\n}\n\n/* map 2/3 | list 1/3 inside the right column */\n.map-and-list {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.map-container {\n  width: 100%;\n  height: 460px;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.locations-list {\n  max-height: 460px;\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n.locations-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.locations-list::-webkit-scrollbar-track {\n  background: #F7E9D2;\n  border-radius: 4px;\n}\n\n.locations-list::-webkit-scrollbar-thumb {\n  background: #D4A574;\n  border-radius: 4px;\n}\n\n.locations-list::-webkit-scrollbar-thumb:hover {\n  background: #C19A6B;\n}\n\n.location-item {\n  display: flex;\n  gap: 12px;\n  padding: 12px;\n  background: #FAF6E7;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  transition: all 0.3s ease;\n  border-left: 4px solid #D4A574;\n}\n\n.location-item:hover {\n  background: #F7E9D2;\n  transform: translateX(3px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.location-item[style*=\"cursor: pointer\"]:hover {\n  background: #E8D5B7;\n  border-left-color: #7B2323;\n}\n\n.location-item[style*=\"cursor: pointer\"]:active {\n  transform: translateX(2px);\n}\n\n.location-icon {\n  min-width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border-radius: 50%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 6px;\n  flex-shrink: 0;\n}\n\n.location-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.location-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.location-details h4 {\n  margin: 0 0 4px 0;\n  font-size: 0.95rem;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.location-type {\n  margin: 0 0 3px 0;\n  font-size: 0.82rem;\n  color: #7B2323;\n  font-weight: 600;\n}\n\n.location-type a {\n  color: #7B2323;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.location-type a:hover {\n  color: #3D1818;\n  text-decoration: underline;\n}\n\n.location-address {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #5D3A3A;\n  line-height: 1.4;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Responsive ──────────────────────────────────────────── */\n@media (max-width: 1100px) {\n  .find-us-split--active {\n    grid-template-columns: 1fr; /* stack on medium screens */\n  }\n\n  .find-us-split--active .find-us-events-col {\n    position: static;\n  }\n\n  .map-and-list {\n    grid-template-columns: 3fr 2fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .locations-header h2 {\n    font-size: 2rem;\n    letter-spacing: 2px;\n  }\n\n  .locations-subheader {\n    font-size: 0.95rem;\n  }\n\n  .city-tabs {\n    gap: 8px;\n  }\n\n  .city-tab {\n    padding: 8px 14px;\n    font-size: 0.85rem;\n  }\n\n  .map-and-list {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .map-container {\n    height: 300px;\n  }\n\n  .locations-list {\n    max-height: none;\n  }\n\n  .location-item {\n    padding: 10px;\n  }\n\n  .location-icon {\n    min-width: 32px;\n    height: 32px;\n  }\n\n  .location-details h4 {\n    font-size: 0.9rem;\n    white-space: normal;\n  }\n\n  .location-address {\n    white-space: normal;\n  }\n}\n\n/* ── Calendar teaser ── */\n.locations-header-sub {\n  font-size: 1rem;\n  color: #6b5050;\n  margin: 8px 0 0;\n}\n\n.locations-calendar-teaser {\n  text-align: center;\n  padding: 36px 24px 48px;\n  border-top: 1px solid rgba(61,24,24,.08);\n  margin-top: 32px;\n}\n\n.locations-calendar-teaser p {\n  font-size: 1rem;\n  color: #5a4040;\n  margin: 0 0 12px;\n}\n\n.locations-calendar-link {\n  display: inline-block;\n  padding: 10px 24px;\n  background: #7b2323;\n  color: #fff;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background .2s, transform .2s;\n}\n\n.locations-calendar-link:hover {\n  background: #5a1a1a;\n  transform: translateY(-1px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
